/******************
* Javascript for 'expandingcontent:' Kirby tag
*******************/

if(typeof FN == 'undefined') FN = {};


FN.expandingcontent = {
  init: function(){
    if(!$('.expandingcontent__begin')) return;
    
    // initially hide each content block
    var blocks = $('.expandingcontent__toggle').each(function(){
      FN.expandingcontent.toggleContent($(this), 'hide');
    });
    
    // event handler for toggle links
    $('.expandingcontent__toggle').on('click', function(){
      FN.expandingcontent.toggleContent($(this), 'toggle');
    });
  },
  toggleContent: function(toggleLink, mode){
    var contentStart = $(toggleLink).closest('.expandingcontent__begin');
    var content = $(contentStart).nextUntil('.expandingcontent__end');

    if(mode === "hide" || toggleLink.hasClass('expandingcontent__toggle--visible')){
      content.hide();
      toggleLink.addClass('expandingcontent__toggle--hidden');
      toggleLink.removeClass('expandingcontent__toggle--visible');
    }else{
      content.show();
      toggleLink.addClass('expandingcontent__toggle--visible');
      toggleLink.removeClass('expandingcontent__toggle--hidden');
    }
  }
};




$(document).ready(function(){
  FN.expandingcontent.init();
});
